import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
export function BusinessSection() {
  const businessBullets = ['Sin local físico — desde tu cocina', 'Sin inversión inicial — solo ingredientes básicos', 'Con un producto que SE VENDE SOLO por su imagen', 'El Método incluye guía de precios y presentación'];
  return <section className="bg-brand-gold-dark py-12 md:py-16 relative overflow-hidden" data-id="element-41">
      {/* Subtle texture/pattern overlay */}
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(#fff_1px,transparent_1px)] [background-size:20px_20px]" data-id="element-42"></div>

      <div className="max-w-5xl mx-auto px-4 relative z-10" data-id="element-43">
        <FadeIn data-id="element-44">
          <div className="flex justify-center mb-8" data-id="element-45">
            <span className="bg-brand-dark text-brand-gold px-6 py-2 rounded-full text-sm font-bold tracking-wider uppercase shadow-lg border border-brand-gold/30" data-id="element-46">
              💡 DATO QUE POCOS CONOCEN
            </span>
          </div>

          <h2 className="text-3xl md:text-5xl font-bold text-white text-center mb-12 leading-tight" data-id="element-47">
            Una Milhojas de 2.5 kg se vende hasta $180.000 — y vos podés hacerla
            con ingredientes de almacén
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center mb-16" data-id="element-48">
          <FadeIn delay={0.2} direction="left" data-id="element-49">
            <div className="text-brand-cream/90 text-lg md:text-xl space-y-6 leading-relaxed" data-id="element-50">
              <p data-id="element-51">
                Muchas de las alumnas de Stella empezaron aprendiendo para sus
                familias. Pero cuando vieron las caras de sus invitados...
                entendieron algo:
              </p>
              <p className="font-bold text-white" data-id="element-52">
                Esto tiene un valor altísimo en el mercado.
              </p>
              <p data-id="element-53">
                La milhojas es el postre con mejor relación costo-beneficio de
                la pastelería artesanal:
              </p>
              <ul className="space-y-3 pl-4 border-l-2 border-brand-gold/50" data-id="element-54">
                <li data-id="element-55">• Ingredientes simples (harina, huevos, dulce de leche)</li>
                <li data-id="element-56">
                  • Valor percibido altísimo (capas, técnica, presentación)
                </li>
                <li data-id="element-57">
                  • Precio de venta: entre $90.000 y $180.000 por tarta de 2.5
                  kg
                </li>
                <li data-id="element-58">
                  • Margen real: hasta el 300% sobre el costo de producción
                </li>
              </ul>
            </div>
          </FadeIn>

          <FadeIn delay={0.3} direction="right" data-id="element-59">
            <div className="bg-brand-dark/40 backdrop-blur-sm p-8 rounded-2xl border border-brand-gold/20 shadow-2xl" data-id="element-60">
              <ul className="space-y-6" data-id="element-61">
                {businessBullets.map((bullet, index) => <li key={index} className="flex items-center" data-id="element-62">
                    <span className="text-2xl mr-4 flex-shrink-0" data-id="element-63">💰</span>
                    <span className="text-white font-medium text-lg" data-id="element-64">
                      {bullet}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>

        <FadeIn delay={0.4} className="text-center" data-id="element-65">
          <CTAButton isPayment data-id="element-66">
            🛒 Sí, quiero aprender el método ahora
          </CTAButton>
        </FadeIn>
      </div>
    </section>;
}